"use client"

import React from "react"

interface ProgressBarProps {
  percentage: number
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage }) => {
  return (
    <div className="relative h-[2px] w-full bg-gray-100">
      <div className="h-full bg-nelo-blue transition-all duration-300 ease-in-out" style={{ width: `${percentage}%` }} />
      <div
        className="absolute top-0 z-10 -mt-[4px] h-3 w-3 rounded-full bg-nelo-blue transition-all duration-300 ease-in-out"
        style={{ left: `${percentage}%` }}
      />
    </div>
  )
}

export default ProgressBar
